import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';
import type { KktFindInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-find.dto';

import * as yup from 'yup';

/** Operators response body */
export interface OperatorFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Name */
  name: string;
  /** Legal entity */
  person: string;
  /** Inn */
  inn: string;
  /** Kkts */
  kkts: KktFindInterface[];
}

/** Operator response body - DTO schema */
export const OperatorFindDto = SerdeDtoClass.create<OperatorFindInterface>(FinanceDtoKeysEnum.OPERATOR_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    sortable: true,
    label: 'Имя',
    serializer: yup.string(),
  },
  person: {
    label: 'Юридическое лицо',
    serializer: yup.string(),
  },
  inn: {
    label: 'ИНН',
    serializer: yup.string(),
  },
  kkts: {
    label: 'Кассы',
    nested: FinanceDtoKeysEnum.KKT_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
});
